module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_5010.9a3552eb.png";